﻿import { ProjectMilestoneStatusActions } from "@/enums";

export const displayDescription = (status) =>
  status === ProjectMilestoneStatusActions.Skip ||
  status === ProjectMilestoneStatusActions.Reject ||
  status === ProjectMilestoneStatusActions.Approve ||
  status === ProjectMilestoneStatusActions.Release ||
  status === ProjectMilestoneStatusActions.SubmitForApproval ||
  status === ProjectMilestoneStatusActions.Reenable;
